module.exports = __webpack_public_path__ + "static/anglr-908a7d0274332ba787a4068cd156c001.mp4";